export function setFilterPreference(facet: string, value: boolean): void {
  const currentPreferences = getPreferences();
  currentPreferences[facet] = value;
  localStorage.setItem('preferences', JSON.stringify(currentPreferences));
}

export function getFilterPreference(facet: string) {
  return getPreferences()?.[facet] ?? true;
}

const LANGUAGE_KEY = 'language';

export function setLanguagePreference(language: string): void {
  localStorage.setItem(LANGUAGE_KEY, language);
}

export function getLanguagePreference(): string | null {
  return localStorage.getItem(LANGUAGE_KEY);
}

export function getPreferences() {
  return JSON.parse(localStorage.getItem('preferences') ?? '{}');
}
